// Indian Sikh Store — Heritage Luxe theme JS
(function () {
  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mobile-toggle]');
    if (t) {
      var m = document.querySelector('[data-mobile-menu]');
      if (m) m.classList.toggle('open');
    }
  });

  // Product gallery thumbnail switching
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var type = thumb.getAttribute('data-media-type');
        var src = thumb.getAttribute('data-media-src');
        if (type === 'video') {
          mainWrap.innerHTML = '<video src="' + src + '" controls autoplay playsinline></video>';
        } else if (type === 'external_video') {
          mainWrap.innerHTML = '<iframe src="' + src + '" frameborder="0" allowfullscreen></iframe>';
        } else {
          mainWrap.innerHTML = '<img src="' + src + '" alt="">';
        }
      });
    });
  }

  // Variant selection
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    var optionsRoot = document.querySelector('[data-variant-options]');
    if (!form || !optionsRoot) return;
    var dataEl = document.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var mainWrap = document.querySelector('[data-gallery-main]');
    var selected = {};
    optionsRoot.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var active = group.querySelector('.swatch.active');
      if (active) selected[idx] = active.getAttribute('data-value');
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return (v.options || []).every(function (opt, i) { return selected[i] === opt; });
      });
    }
    function baseName(url) {
      if (!url) return '';
      return url.split('?')[0].split('/').pop();
    }
    function swapImage(v) {
      if (!mainWrap || !v || !v.featured_image || !v.featured_image.src) return;
      var src = v.featured_image.src;
      mainWrap.innerHTML = '<img src="' + src + '" alt="">';
      var want = baseName(src);
      document.querySelectorAll('[data-thumb]').forEach(function (t) {
        var match = baseName(t.getAttribute('data-media-src')) === want;
        t.classList.toggle('active', match);
      });
    }
    function update() {
      var v = findVariant();
      var idInput = form.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-price-now]');
      var addBtn = form.querySelector('[data-add-btn]');
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (addBtn) { addBtn.removeAttribute('disabled'); addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out'; if (!v.available) addBtn.setAttribute('disabled', 'disabled'); }
        swapImage(v);
      }
    }
    optionsRoot.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = sw.closest('[data-option-index]').getAttribute('data-option-index');
        sw.closest('[data-option-index]').querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        selected[idx] = sw.getAttribute('data-value');
        update();
      });
    });
    update();
  }

  function formatMoney(cents) {
    var v = (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    return '₹' + v;
  }

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentElement.querySelector('input');
    var val = parseInt(input.value || '1', 10);
    input.value = Math.max(1, plus ? val + 1 : val - 1);
  });

  // Show more reviews
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-show-reviews]');
    if (!b) return;
    var more = document.querySelector('[data-more-reviews]');
    if (more) more.removeAttribute('hidden');
    b.style.display = 'none';
  });

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariants();
    initTabs();
  });

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      root.querySelectorAll('[data-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-tab');
          root.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.remove('active'); });
          root.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.remove('active'); });
          btn.classList.add('active');
          var panel = root.querySelector('[data-panel="' + key + '"]');
          if (panel) panel.classList.add('active');
        });
      });
    });
  }
})();